import { useState } from "react";
import { PropTypes } from 'prop-types'

const useFilterSearch = (initialData = []) => {
    const [filteredData, setFilteredData] = useState(initialData);

    const handleFilterChange = (searchValue) => {
        if (searchValue !== '') {
            const filteredDatas = initialData.filter((item) => {
                return Object.values(item).join('').toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())
            })
            setFilteredData(filteredDatas)
        }
        else{
            setFilteredData(initialData)
        }
    }

    return [filteredData, handleFilterChange, setFilteredData];
}
useFilterSearch.propTypes = {
	initialData: PropTypes.array,
}
export default useFilterSearch